<template>
  <!-- 轮播图列表父组件 -->
  <div class="carousel-index">
    <!-- 引用公共表格组件 -->
    <!-- 表格 -->
    <div v-if="rightcom !== 'ArticleListIndex'">
      <el-button
        class="custom-btn none"
        size="small"
        @click="handleBackClick()"
      >
        <i class="el-icon-arrow-left primary-color"></i> 返回</el-button
      >
    </div>

    <div v-if="rightcom === 'ArticleListIndex'">
      <CustomTable
        :tableData="tableData"
        :tableHeaders="tableHeaders"
        :showSelection="true"
        :pagination="pagination"
        :loading="tableLoading"
        tableHeight="calc(100vh - 200px)"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <!-- 顶部操作按钮插槽 -->
        <template #top-actions>
          <div class="table-buttons">
            <div
              v-for="button in actionButtons.topArticleButtons"
              :key="button.id"
            >
              <CustomButton
                v-if="
                  button.id === 'add' ||
                  button.id === 'release' ||
                  button.id === 'delete' ||
                  button.id === 'edit'
                "
                :text="button.text"
                size="medium"
                :icon="button.icon"
                fontSize="14px"
                :customStyle="button.customStyle"
                @click="handleClick(button)"
              />
            </div>
          </div>
        </template>
        <template #action="{ row }">
          <div class="action-buttons">
            <el-button
              v-for="button in actionButtons.tableArticleButtons"
              :key="button.id"
              class="custom-btn none"
              size="small"
              @click="handleClick(button, row)"
              >{{ button.text }}</el-button
            >
          </div>
        </template>
        <template #status="{ row, column, index }">
          <div v-if="column.property === 'status'">
            <!-- 根据状态值显示不一样的小按钮颜色 -->
            <span class="status one" v-if="row[column.property] == 1"
              >已发布</span
            >
            <span class="status one" v-if="row[column.property] == 2"
              >未推送到公众号</span
            >
            <span class="status two" v-if="row[column.property] == 3"
              >草稿</span
            >
            <span class="status three" v-if="row[column.property] == 0"
              >已下架</span
            >
          </div>
        </template>
      </CustomTable>
    </div>
    <div v-else>
      <ArticleListEdit :datas="selectedRows[0]" />
    </div>
    <!-- 发布完成 -->
    <CustomElDialog
      :visible.sync="showDialogSuccess"
      width="500px"
      height="310px"
      close-btn-position="top-right"
      :has-top-image="true"
      top-image-top="-70px"
      top-image-position="center"
      :close-on-overlay-click="true"
      dialogBgGradient="linear-gradient(180deg, #B7D7FF 0%, #FFFFFF 59%)"
      dialogRadius="15px"
    >
      <template #topContent>
        <div class="custom-top-content">
          <img :src="$serverImgUrl + 'popup10.png'" style="max-height: 150px" />
        </div>
      </template>
      <template #content>
        <div
          class="custom-content"
          style="margin-top: 10px; padding-left: 10px; text-align: center"
        >
          <h2
            style="
              font-size: 30px;
              font-weight: bold;
              color: #348cf8;
              padding-top: 20px;
            "
          >
            恭喜发布完成
          </h2>
          <p
            style="
              margin-top: 30px;
              margin-right: 25px;
              font-size: 16px;
              font-weight: normal;
              line-height: 25px;
              letter-spacing: 0em;
              color: #26426c;
              text-align: center;
            "
          >
            <span style="padding-left: 30px"> 官网链接</span>
            <a
              href="https://example.com/payment-confirm"
              class="help-link"
              target="_blank"
            >
              https://example.com/payment-confirm
            </a>
            <i class="el-icon-document-copy f25 color-back"></i>
          </p>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer" style="text-align: center">
          <el-button class="cancel-btn" style="background-color: transparent"
            >添加到公众号菜单</el-button
          >
          <el-button class="confirm-btn" style="width: 100px; margin-left: 50px"
            >确认</el-button
          >
        </div>
      </template>
    </CustomElDialog>
    <!-- 发布弹窗-->
    <CustomElDialog :visible.sync="showDialog" width="600px" height="auto">
      <template #content>
        <ArticleReleaseArrive
          v-if="!publishToForm"
          :tableData="tableData"
          @confirm="handleConfirm"
          @cancel="
            () => {
              (publishToForm = null), (showDialog = false);
            }
          "
        />
        <ArticleSort
          v-else
          :tableData="tableData"
          @confirm="handleConfirm"
          @cancel="
            () => {
              (publishToForm = null), (showDialog = false);
            }
          "
        />
      </template>
    </CustomElDialog>
  </div>
</template>
<script>
import { color } from "echarts";
// 引入文章表格的列配置
import {
  tableHeaders,
  dialogTableHeaders,
  actionButtons,
} from "@/utils/defaultData";
export default {
  name: "ArticleListIndex",
  props: {
    datas: Object,
  },
  data() {
    return {
      confirmLoading: false,
      loading: false,
      publishLoading: false,
      draggingIndex: -1, // 正在拖拽的行索引
      dropIndex: -1, // 目标放置索引
      isDragging: false, // 是否处于拖拽状态
      // 动态渐变背景
      dialogGradient: "linear-gradient(180deg, #DDF1FF 0%, #FFFFFF 100%)",
      backgroundImage: this.$serverImgUrl + "popup9.png",
      selectedOption: 1,
      // 发布弹窗
      showDialog: false,
      showDialogSuccess: false,
      publishToForm: null, //发布值弹窗表单
      rightcom: "ArticleListIndex",
      pagination: {
        total: 14,
        currentPage: 1,
        pageSize: 10,
      },

      scope: {},
      // 选中的行数据
      selectedRows: [],
      columns: [],
      tableLoading: false,
      // 新增按钮配置数组
      actionButtons: actionButtons,
      tableData: [],
      // 使用文章表格的列配置
      tableHeaders: tableHeaders.articleTable,
    };
  },
  create() {
    this.getList();
  },
  created() {
    // 获取推文列表
    this.getTweetList();
  },
  mounted() {
    console.log("打印默认数据", this.tableHeaders);
  },
  methods: {
    // 获取推文列表
    getTweetList() {
      this.$api.admin.tweet.getTweetListAPI().then((res) => {
        console.log("获取推文列表999999999999999999", res);
        if (res.code === 200) {
          this.tableData = res.data;
        }
      });
    },
    //  发布至弹窗子组件确定按钮回调
    handleConfirm(params) {
      this.publishToForm = params;
      console.log("发布至弹窗子组件确定按钮回调", params);
      if (params === "success") {
        this.showDialog = false;
        this.showDialogSuccess = true;
        this.$message({
          message: "发布成功",
          type: "success",
        });
      }
    },
    // 选项切换方法
    selectedOptionChange(option) {
      this.selectedOption = option;
    },
    // 行点击处理方法
    handleRowClick(button, row) {
      console.log("点击了按钮", button, row);
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    // 上架
    handleOnlineClick(button, row) {
      console.log("表格行点击了上架按钮", button, row);
      // 可以在这里添加上架逻辑
    },
    // 编辑
    handleRowEditClick(button, row) {
      console.log("表格行点击了编辑按钮", button, row);
      // 可以在这里添加编辑逻辑
      this.rightcom = "ArticleListEdit";
    },
    // 删除
    handleRowDeleteClick(button, row) {
      console.log("表格行点击了删除按钮", button, row);
      // 可以在这里添加删除逻辑
    },
    // 返回上一页
    handleBackClick() {
      console.log("点击了返回按钮", this.rightcom);
      // 可以在这里添加返回逻辑
      this.rightcom = "ArticleListIndex";
    },
    // 按钮点击处理方法
    handleClick(button, row) {
      console.log("点击了按钮", button);
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    // 按钮点击处理方法
    handleAddClick(button) {
      console.log("点击了新增按钮");
      this.rightcom = "ArticleListEdit";
      // 可以在这里添加新增逻辑
    },

    handleEditClick(button) {
      console.log("点击了修改按钮", button, this.selectedRows);
      // 可以在这里添加修改逻辑，通常需要检查是否有选中行
      if (this.selectedRows.length === 0) {
        this.$message.warning("请先选择要修改的数据");
        return;
      }
      // 修改逻辑...
      this.rightcom = "ArticleListEdit";
    },
    // 发布文章
    handleReleaseClick(button) {
      console.log("点击了发布按钮", button, this.selectedRows);
      this.showDialog = true;
      this.publishToForm = null; //发布至弹窗表单内容初始化
      // 可以在这里添加发布逻辑，通常需要检查是否有选中行
      // if (this.selectedRows.length === 0) {
      //   this.$message.warning("请先选择要发布的数据");
      //   return;
      // }
      // // 发布逻辑...
      // this.showDialog = true;
    },

    handleDeleteClick() {
      console.log("点击了删除按钮");
      // 可以在这里添加删除逻辑，通常需要检查是否有选中行并二次确认
      // if (this.selectedRows.length === 0) {
      //   this.$message.warning("请先选择要删除的数据");
      //   return;
      // }
      // 删除确认对话框和删除逻辑...
      this.$confirm(
        "确认删除选中的" + this.selectedRows.length + "条数据吗？",
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          // 执行删除操作
          this.$message({
            type: "success",
            message: "删除成功",
          });
          // 刷新数据列表
          this.getList();
        })
        .catch(() => {
          // 取消删除操作
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 处理每页显示条数变化
    handleSizeChange(newPagination) {
      console.log("每页条数变化", newPagination);
      this.pagination = newPagination;

      // this.getList();
    },
    // 处理页码变化
    handleCurrentChange(newPagination) {
      this.tableLoading = true;
      console.log("页码变化", newPagination);
      this.tableData = [
        {
          name: "最后加的",
          type: "男",
          image:
            "https://beihai-food.oss-cn-beijing.aliyuncs.com/pic/avatar.png",
          uploadTime: "2025-09-11 10:00:00",
          uploadUser: "admin",
          status: false,
        },
      ];
      // this.pagination = newPagination;
      // this.getList();
    },
    // 处理选择事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("父组件中选项变更了", this.selectedRows);
    },
    handleStatusChange(row, prop, val) {
      console.log("改变了", row, prop, val);
    },
    getList() {
      // 获取数据
      this.tableLoading = true;
      fetchList(
        Object.assign(
          { currrent: this.page.current, size: this.page.size },
          this.searchForm,
        ),
      )
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    // 上移功能
    moveUp(index) {
      if (index > 0) {
        // 创建数据副本以触发Vue的响应式更新
        const newData = [...this.dialogTableData];
        // 交换位置
        const temp = newData[index];
        newData[index] = newData[index - 1];
        newData[index - 1] = temp;
        // 更新数据
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行上移`);
      }
    },

    // 下移功能
    moveDown(index) {
      if (index < this.dialogTableData.length - 1) {
        // 创建数据副本以触发Vue的响应式更新
        const newData = [...this.dialogTableData];
        // 交换位置
        const temp = newData[index];
        newData[index] = newData[index + 1];
        newData[index + 1] = temp;
        // 更新数据
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行下移`);
      }
    },

    // 发布推文确认
    async handlePublishConfirm() {
      this.publishLoading = true;
      try {
        // 准备请求数据
        const requestData = {
          articleIds: this.dialogTableData.map((item) => item.articleId),
          publishMode: "now", // 立即发布
        };

        // 调用发布推文接口
        const response = await this.$api.admin.article.publishArticleAPI(
          requestData,
        );
        if (response.status === 200) {
          this.$message.success("推文发布成功");
          this.showDialog = false;
          // 刷新列表数据
          this.getList();
        } else {
          this.$message.error(response.msg || "推文发布失败");
        }
      } catch (error) {
        console.error("发布推文异常:", error);
        this.$message.error(error.message || "推文发布失败");
      } finally {
        this.publishLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel-index {
  padding: 10px;
}
.status {
  display: inline-block;
  // width: 60px;
  padding: 4px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}
.status.one {
  background-color: #e6f7f1;
  color: #43c393;
}
.status.two {
  background-color: #e5effd;
  color: #348cf8;
}
.status.three {
  background-color: #feeeee;
  color: #f76565;
}

/* 发布选项弹窗样式 */
.dialog-content {
}

.publish-selection {
  width: 100%;
}

.selection-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
}

.selection-subtitle {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 0 0 30px 0;
}
.publish-option.border {
  border: 1px solid #348cf8;
}
.publish-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.publish-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.primary-option {
  background-color: #409eff;
  color: white;
}

.secondary-option {
  background-color: #f0f9ff;
  color: #333;
  border: 1px solid #e1f3ff;
}

.option-content h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.primary-option .option-content h4 {
  color: white;
}

.secondary-option .option-content h4 {
  color: #333;
}

.option-content p {
  font-size: 14px;
  margin: 4px 0;
  line-height: 1.4;
}

.primary-option .option-content p {
  color: rgba(255, 255, 255, 0.9);
}

.secondary-option .option-content p {
  color: #666;
}

.publish-option i {
  font-size: 18px;
}

.primary-option i {
  color: white;
}

.secondary-option i {
  color: #409eff;
}
</style>
